export default "__VITE_ASSET__DesnGSvl__"